/**
 * Back-compat barrel — derives `TYPE_CONTENT` from the new express playbooks
 * so existing consumers (simulator components) continue compiling without
 * change. Source of truth is now `src/features/decodificar/express/playbooks.ts`.
 */
import type { EnneagramTypeId } from "@/types/supabase";
import { PLAYBOOKS } from "../express/playbooks";
import type { Playbook } from "../express/types";

export interface TypeContent {
  id: EnneagramTypeId;
  name: string;
  shortDescription: string;
  communicationStyle: string;
  sellingApproach: string;
  objections: string[];
  doNot: string[];
}

function fromPlaybook(p: Playbook): TypeContent {
  return {
    id: p.id,
    name: p.name,
    shortDescription: p.shortDescription,
    communicationStyle: p.signature,
    sellingApproach: p.closingFrame,
    objections: [p.keyPhrase],
    doNot: p.avoid,
  };
}

export const TYPE_CONTENT: Record<EnneagramTypeId, TypeContent> = {
  1: fromPlaybook(PLAYBOOKS[1]),
  2: fromPlaybook(PLAYBOOKS[2]),
  3: fromPlaybook(PLAYBOOKS[3]),
  4: fromPlaybook(PLAYBOOKS[4]),
  5: fromPlaybook(PLAYBOOKS[5]),
  6: fromPlaybook(PLAYBOOKS[6]),
  7: fromPlaybook(PLAYBOOKS[7]),
  8: fromPlaybook(PLAYBOOKS[8]),
  9: fromPlaybook(PLAYBOOKS[9]),
};

export function getTypeContent(id: EnneagramTypeId): TypeContent {
  return TYPE_CONTENT[id];
}

export const TYPE_ACCENT: Record<EnneagramTypeId, string> = {
  1: "#ef4444",
  2: "#f97316",
  3: "#eab308",
  4: "#22c55e",
  5: "#14b8a6",
  6: "#06b6d4",
  7: "#3b82f6",
  8: "#6366f1",
  9: "#a855f7",
};
